import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { Enum, IEnumTranslator, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ReturnInvoiceRequestDetailView } from "../returnInvoiceRequestDetail/returnInvoiceRequestDetail-view";
import { ReturnInvoiceRequestDetailViewModel } from "../returnInvoiceRequestDetail/returnInvoiceRequestDetail-viewModel";
import  { ReturnInvoiceRequestsListView } from "./returnInvoiceRequestsList-view"

export class ReturnInvoiceRequestsListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'درخواست‌های فاکتورهای مرجوعی ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.requestStateEnumProvider = new ReturnInvoiceRequestStateEnumProvider();
        this.returnInvoiceRequests = ObservableArray.create<ReturnInvoiceRequest>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ReturnInvoiceRequestsListView();
    }
    public getTypeId(): string {
        return "VM-CE1DFFD1-6D57-450A-8728-1854FA138D54"
    }
    public set requestStateEnumProvider(v: ReturnInvoiceRequestStateEnumProvider) { this._requestStateEnumProvider = v; } public get requestStateEnumProvider(): ReturnInvoiceRequestStateEnumProvider { return this._requestStateEnumProvider;} private _requestStateEnumProvider: ReturnInvoiceRequestStateEnumProvider;
    public set returnInvoiceRequests(v: ObservableArray<ReturnInvoiceRequest>) { this._returnInvoiceRequests = v; } public get returnInvoiceRequests(): ObservableArray<ReturnInvoiceRequest> { return this._returnInvoiceRequests;} private _returnInvoiceRequests: ObservableArray<ReturnInvoiceRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    refresh(){
        this.loader.refresh();
    }
    
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'createdTime',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            let result = await ServerConnection.callServer('/Complex/SellServices/GetAllReturnInvoiceRequestsList',{
                FilteringInformation:filteringInformation
            });
            
            this.returnInvoiceRequests.update(...result.ReturnInvoiceRequests.map((q,rowNumber)=>{
                let r = new ReturnInvoiceRequest(this);
                r.id = q.RequestId;
                r.rowNumber = rowNumber+1;
                r.customerName = q.CustomerName;
                r.creatorName = q.Creator;
                r.referenceInvoiceNumber = q.ReferenceInvoiceNumber;
                r.returnInvoiceId = q.ReturnInvoiceId;
                r.returnInvoiceNumber = q.ReturnInvoiceNumber;
                r.warehouseId = q.DeliveryWarehouseId,
                r.warehouseName = q.DeliveryWarehouseName,
                r.requestNumber = q.RequestNumber;
                r.creationTime = moment.utc(q.RequestCreatedTime);
                r.referenceCreatedTime = moment.utc(q.ReferenceCreatedTime);
                r.state = q.State;
                r.needConfirm = r.state == 1;
                r.confirmed = r.state == 2;
                r.rejected = r.state == 3;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async showDetail(selectedId:any) {
        let inserter = new ReturnInvoiceRequestDetailViewModel(this, selectedId);
        let resultCode = await this.showPopup(inserter);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async rejectSelected(selectedId:any):Promise<void>{
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','رد کردن درخواست ها');
        if(result=='yes'){
            try {
                this.isLoading = true;
                await ServerConnection.callServer('/Complex/SellServices/RejectReturnInvoiceRequest',{
                    Id: selectedId
                });
                await this.messageBoxConfirmSuccess('درخواست رد شد.','عملیات موفق');
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            } finally {
                this.isLoading = false;
                this.loader.refresh();
            }
        }
    }

}

export class ReturnInvoiceRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReturnInvoiceRequestsListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName;} private _creatorName: string;
    public set referenceInvoiceNumber(v: string) { this._referenceInvoiceNumber = v; } public get referenceInvoiceNumber(): string { return this._referenceInvoiceNumber;} private _referenceInvoiceNumber: string;
    public set requestNumber(v: number) { this._requestNumber = v; } public get requestNumber(): number { return this._requestNumber;} private _requestNumber: number;
    public set returnInvoiceNumber(v: number) { this._returnInvoiceNumber = v; } public get returnInvoiceNumber(): number { return this._returnInvoiceNumber;} private _returnInvoiceNumber: number;
    public set returnInvoiceId(v: number) { this._returnInvoiceId = v; } public get returnInvoiceId(): number { return this._returnInvoiceId;} private _returnInvoiceId: number;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set referenceCreatedTime(v: moment.Moment) { this._referenceCreatedTime = v; } public get referenceCreatedTime(): moment.Moment { return this._referenceCreatedTime;} private _referenceCreatedTime: moment.Moment;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    public set confirmed(v: boolean) { this._confirmed = v; } public get confirmed(): boolean { return this._confirmed;} private _confirmed: boolean;
    public set rejected(v: boolean) { this._rejected = v; } public get rejected(): boolean { return this._rejected;} private _rejected: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    private _typedParent:ReturnInvoiceRequestsListViewModel;

    async showDetail() {
        this._typedParent.showDetail(this.id);
    }

    async rejectRequest(){
        this._typedParent.rejectSelected(this.id);
    } 
    
}

interface IServerUpdater{
    execute(customerCreationRequest:ReturnInvoiceRequest):Promise<void>;
    getSuccessMessage():string;
}

export class ReturnInvoiceRequestStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [1,2,3];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateCustomerRequestState(value);
    }
}